var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddProductCartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3611_1395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 9.82547V15.6826C9.14286 16.2349 8.69514 16.6826 8.14286 16.6826H7.85714C7.30486 16.6826 6.85714 16.2349 6.85714 15.6826V9.82547H1C0.447715 9.82547 0 9.37776 0 8.82547V8.53976C0 7.98748 0.447715 7.53976 1 7.53976H6.85714V1.68262C6.85714 1.13033 7.30486 0.682617 7.85714 0.682617H8.14286C8.69514 0.682617 9.14286 1.13033 9.14286 1.68262V7.53976H15C15.5523 7.53976 16 7.98748 16 8.53976V8.82547C16 9.37776 15.5523 9.82547 15 9.82547H9.14286Z",
    fill: "#2246DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3611_1395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.682617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProductCartIcon);
export default __webpack_public_path__ + "static/media/add-product-cart-icon.fe4f91a4c666319d0a9958132bd61e0b.svg";
export { ForwardRef as ReactComponent };